export default __webpack_public_path__ + "search-examples-search-ui-and-maps-sdk-1200-3df3790ebc6de1b6bb5c7f6143192809.png";